//ChangeDataView.vue



<template>

  <div>

	<!-- <div id="background-color">   
	</div> -->

	<div id="background">

		<img id="project-image" :src="'imgs/projects/Background2.jpg'" />


		<h2 id="view-title" v-if="isAdmin">
			Please be careful when making changes to the database. <br>
			It may affect all further calculations.
		</h2>
		<h2 id="view-title" v-if="!isAdmin">
			Use admin rights to make changes to the data base
		</h2>
	</div>

	<!-- <div id="background">
		<h2 id="view-title" v-if="isAdmin">
			Please be careful when making changes to the database. <br>
			It may affect all further calculations.
		</h2>
		<h2 id="view-title" v-if="!isAdmin">
			Use admin rights to make changes to the data base
		</h2>
	</div> -->

	<div id="change-material">
		<Material />
	</div> 

	<div id="header">
		<HeaderBasic />
	</div>  

  </div>

</template>

<script>


import HeaderBasic from "../components/HeaderBasic.vue";
import Material from "../components/Material.vue";

export default {
	components: {
		HeaderBasic,
		Material
	},
	data() {
		return {
			isAdmin: false
	};
	},
	methods: {
		isUserAdmin() {

			console.log('localStorage.adminStatus from ChangeDataView', localStorage.adminStatus);

			if(localStorage.adminStatus == '"admin"') {
				this.isAdmin = true;
			}
		}
	},
	mounted() {
		this.isUserAdmin();
	}
};
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

#background-color {
	top: 0;
	left: 0;
	height: 100vh;
	width: 100vw;
	background: rgba(145, 145, 145, 0.2);
	position: absolute;
	background-image: linear-gradient(rgba(220, 220, 222, 1),rgba(194, 194, 207, 0.8));
}

#background {
	top: 0;
	left: 0;
	height: 100vh;
	width: 100vw;
	background: rgba(145, 145, 145, 0.2);
	position: absolute;
	background-image: linear-gradient(rgba(220, 220, 222, 1),rgba(194, 194, 207, 0.8));
}

/* #background {
  background: transparent;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  position: absolute;
} */

#project-image {
	width: 100vw;
	top: 0%;
	left: 0%;
	position: fixed;
	opacity: .05;
}

#view-title {
	top:10%;
	left: 25%;
	position: fixed;
	color: rgba(0, 0, 0, .7);
	/* font-family: Roboto; */
	font-family: 'Roboto', sans-serif;
	text-align: left;
	/* margin-left: 30px; */
	/* padding-top: 20px; */
	font-weight: 200;
	font-size: 1.0rem;
	text-align: left;
	/* border: 1px solid black; */
}

#view-title h2 {
	font-weight: 300;
	font-size: 12px;
	text-align: left;
	margin-left: 30px;
	padding-top: 20px;
}

#view-description {
	top:14%;
	left: 10%;
	position: fixed;
	color: black;
	/* font-family: Roboto; */
	font-family: 'Roboto', sans-serif;
	font-weight: 200;
	text-align: left;
	margin-left: 30px;
	padding-top: 20px;
}

#header {
	position: fixed;
	top: 2%;
}

#change-material {
	position: fixed;
	top: 20%;
	left: 25%;
}

</style>









